/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MoreVerticalLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 3c-.82 0-1.5.67-1.5 1.5S11.18 6 12 6s1.5-.67 1.5-1.5S12.82 3 12 3m0 15c-.82 0-1.5.68-1.5 1.5S11.18 21 12 21s1.5-.68 1.5-1.5S12.82 18 12 18m0-7.5c-.82 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.68-1.5-1.5-1.5" />
  </Icon>
);
